import React from "react";

const IconExport = (props) => {
  const { size = 20, ...rest } = props;
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} {...rest} viewBox="0 0 16 16" fill="currentColor">
      <path d="M8.9974 3L8.9974 8.43333L10.7307 6.7L11.6641 7.66667L8.33073 11L4.9974 7.66667L5.93073 6.7L7.66406 8.43333L7.66406 3L8.9974 3Z" fill="currentColor"/>
      <path d="M4.33333 13.6341C3.96667 13.6341 3.65278 13.5036 3.39167 13.2424C3.13056 12.9813 3 12.6674 3 12.3008V10.3008H4.33333V12.3008H12.3333V10.3008H13.6667V12.3008C13.6667 12.6674 13.5361 12.9813 13.275 13.2424C13.0139 13.5036 12.7 13.6341 12.3333 13.6341H4.33333Z" fill="currentColor"/>
    </svg>
  );
};

export default IconExport;